import React, { useMemo, useState } from 'react';

import { ObjectSchema } from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CreateAviatorRoleFormContext,
  CreateAviatorRoleFormState,
  createAviatorRoleFormStateDefault,
  createAviatorRoleSchemaDefault,
} from '@Forms/aviatorRoles/CreateAviatorRoleFormContext';

export const CreateAviatorRoleFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateAviatorRoleFormState>>>(
    createAviatorRoleSchemaDefault
  );
  const methods = useForm({
    defaultValues: createAviatorRoleFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateAviatorRoleFormContext.Provider value={value}>
      {children}
    </CreateAviatorRoleFormContext.Provider>
  );
};
